module.exports = __webpack_public_path__ + "img/change-billing.b7d4e612.svg";